import { ReviewsStore, ReviewsResponse } from '../types';
import { extractReviewsAllPhotos } from './extract-reviews-all-photos';
import {
  extractFacetsByScore,
  extractGallery,
  extractReviews,
  extractReviewsPageMeta,
  extractTotalRating,
  extractTotalRatingBy,
} from './response-processor';

export const processFetchedResult = (data: ReviewsResponse): ReviewsStore => {
  return {
    productId: data.product.product_id,
    groupId: data.product.group_id,
    recommended: data.product.recommended,
    rating: {
      total: extractTotalRating(data),
      byPrice: extractTotalRatingBy('price', data),
      byQuality: extractTotalRatingBy('quality', data),
    },
    facets: {
      byScore: extractFacetsByScore(data),
    },
    gallery: extractGallery(data),
    reviewsCards: extractReviews(data),
    allPhotos: extractReviewsAllPhotos(data),
    pageMeta: extractReviewsPageMeta(data),
  };
};
